import TrialVipsApp from './CompaniesApp';
import React from 'react';
import {Redirect} from 'react-router-dom';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const CompaniesAppConfig = {
    auth: authRoles.admin, //  ['admin']
    routes: [
        {
            path: '/apps/company/:id',
            component: TrialVipsApp
        },
        {
            path: '/apps/company',
            component: () => <Redirect to="/apps/company/all"/>
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/company/CompaniesAppConfig.js